import type { Group, GroupTypeKey } from '@/shared/types/group';

export type PartialGroup = {
  id: string;
  data: Partial<Group['data']>;
};

export interface GroupPropertiesEntry {
  alias: {
    type: string;
    oversight: string;
  };
  icon: string;
}

export type GroupPropertiesKey = keyof GroupPropertiesEntry;

export const GroupProperties: Record<GroupTypeKey, GroupPropertiesEntry> = {
  laygroup1: {
    alias: {
      type: 'Sheepfold Section',
      oversight: 'Oversight',
    },
    icon: 'mdi:account-supervisor-circle',
  },
  laygroup2: {
    alias: { type: 'Sheepfold Group', oversight: 'Leader' },
    icon: 'mdi:account-group',
  },
  team: {
    alias: { type: 'Team', oversight: 'Captain' },
    icon: 'ic:baseline-group-work',
  },
  group: {
    alias: { type: 'Tribe', oversight: 'Leader' },
    icon: 'mdi:people-group',
  },
  pcogroup: {
    alias: { type: 'PCO Group', oversight: 'Group Leader' },
    icon: 'mdi:account-group-outline',
  },
};

export interface State {
  data: Group[];
  allLoaded: boolean;
  campusLoaded: Set<string>;
}

export interface LayGroupNode {
  item: Group;
  parent: LayGroupNode | null;
  children: LayGroupNode[] | null;
}

export type LoadLayGroupsResponse = Group[];
export interface LoadLayGroupsRequest {
  campus?: string[];
}

export type CreateLayGroupResponse =
  | ({
      created: true;
    } & Group)
  | { created: false };

export type UpdateLayGroupsResponse = { updated: true } & Group;
